import React from 'react';
import { Chip } from '@mui/material';
import { fonts } from '../theme/index.js';
import { useTheme } from '@mui/system';

/**
 * @param isSelected
 * @param onClick
 * @param label
 * @param customStyle
 * @param clickable
 * @returns {*}
 * @constructor
 */
const Bubble = ({
  isSelected,
  onClick,
  label,
  customStyle,
  clickable = true,
  disabled,
  disabledHover,
  rightIcon,
  onClickRightIcon
}) => {
  const theme = useTheme();
  return /*#__PURE__*/React.createElement(Chip, {
    size: "medium",
    label: label,
    color: disabled ? "default" : "primary",
    clickable: disabled ? false : clickable,
    variant: isSelected ? 'default' : 'outlined',
    deleteIcon: rightIcon,
    onDelete: onClickRightIcon,
    sx: {
      cursor: disabled ? "default" : 'pointer',
      padding: "20px",
      margin: "10px 0",
      borderRadius: "20px",
      borderWidth: "2px",
      fontFamily: fonts.type.heading,
      fontSize: 14,
      color: isSelected ? '#FFF' : '#000',
      minWidth: "170px",
      letterSpacing: '0.01071em',
      '&:hover': {
        backgroundColor: disabledHover ? null : theme.palette.custom.bubbleHover
      },
      ...customStyle
    },
    onClick: disabled ? null : onClick
  });
};
export default Bubble;